<template>
	<v-row class="kanban-board flex-nowrap" no-gutters>
		<v-col v-for="col in columns" :key="col.id" class="kanban-board__col px-2">
			<kanban-column
				:column="col"
				:items="items[col.id] || []"
				:count="counts[col.id] || 0"
				:loading="loadingColumns.includes(col.id)"
				@card-action="$emit('card-action', $event)"
			>
				<template #card="{ item }">
					<slot name="card" :item="item" :column="col" />
				</template>
				<template v-if="$slots['column-footer']" #footer>
					<slot name="column-footer" :column="col" />
				</template>
			</kanban-column>
		</v-col>
	</v-row>
</template>

<script>
import KanbanColumn from "./KanbanColumn.vue";

export default {
	name: "KanbanBoard",

	components: {
		KanbanColumn,
	},

	props: {
		columns: {
			type: Array,
			required: true,
		},
		items: {
			type: Object,
			default: () => ({}),
		},
		counts: {
			type: Object,
			default: () => ({}),
		},
		// Ids of columns whose cards are being fetched (KanbanColumn `loading`).
		loadingColumns: {
			type: Array,
			default: () => [],
		},
	},

	emits: ["card-action"],
};
</script>

<style scoped lang="scss">
.kanban-board {
	overflow-x: auto;

	&__col {
		// Every column claims an equal share of the available width (item 4).
		// No max-width cap, so 3 or 5 columns both fill the board evenly; the
		// min-width only sets the point where horizontal scroll kicks in.
		min-width: 260px;
		flex: 1 1 0;
	}
}
</style>
